<template>
    <router-view v-resize-init="useThrottle(callTaskList)"/>
    <!-- <div id="modals"></div> -->
</template>

<script lang="ts" setup>
import { callTaskList } from "@/app/providers/directives/Resize/state"
import { setCookie } from "@/plugins/cookie";
import { useThrottle } from "@/shared/lib/utils"
import { useI18n } from "vue-i18n";

const { locale } = useI18n();

locale.value = 'ru';

setCookie('language', 'ru')
localStorage.setItem('locale', 'ru');

const publicRoutes = ['/doc/', '/policy', '/auth', '/register'];

if (publicRoutes?.some?.(route => location?.href?.includes?.(route)) == false) {
    localStorage.setItem('location', location?.pathname + location?.search)
}

</script>

<style lang="scss">

#app {
    width: 100vw;
    height: 100vh;
    // overflow: hidden;
}

// #modals {
//     position: fixed;
//     top: 0;
//     bottom: 0;
//     left: 0;
//     right: 0;
// }
// #modals:not(:empty):has(*) {
//     z-index: 9999;
// }

</style>
